// extracted by mini-css-extract-plugin
module.exports = {"root":"Customer_root__B_qtC","row":"Customer_row__2AXaW"};